module.exports = {
  ESCAPE_KEY: 27,

  stylePrefix: 'com-',

  defaults: [],

  // Editor model
  // @deprecated
  em: null,

  // If true center new first-level components
  // @deprecated
  firstCentered: true,

  // If true the new component will created with 'height', else 'min-height'
  // @deprecated
  newFixedH: false,

  // Minimum height (in px) of new component
  // @deprecated
  minComponentH: 50,

  // Minimum width (in px) of component on creation
  // @deprecated
  minComponentW: 50
};
